/** Shown for the 410 (dead/rotated/revoked link) state. */
export function DeadLinkNotice() {
  return (
    <main className="flex flex-1 items-center justify-center px-6 py-16">
      <div className="max-w-sm text-center">
        <div className="mb-4 text-4xl" aria-hidden="true">
          🔗
        </div>
        <h1 className="text-xl font-semibold text-slate-900">
          This check-in link is no longer active
        </h1>
        <p className="mt-3 text-sm text-slate-600">
          The QR code you scanned may have been replaced. Ask the store for the
          current one, or check in at the counter.
        </p>
      </div>
    </main>
  );
}
